module.exports = __webpack_public_path__ + "img/voestalpine.a20075ae.svg";